import { ContainerService } from '../../../data/services'
import { Container } from '../../../data/models'
import { IDataServiceConfig, ModelRepository } from '../../../model-repository'
import { IEntityMappingConfig } from '../../..'

export const ContainerConfig: IDataServiceConfig<Container> = {
  service: ContainerService,
  deps: [ModelRepository],
  endpoint: 'exams/containers',
  model: Container,
  presenter: null,
  backend: 'uncached',
  mappings: [{
    classType: 'Container',
    jsonType: 'containers',
    propertyMapping: {
      questions: {
        isCollection: true
      }
    }
  }]
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/data/container.config.ts